import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, Loader2 } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";

interface RefreshIconButtonProps {
	onClick: () => void;
	loading?: boolean;
	className?: string;
	tooltip?: string;
}

interface RefreshButtonProps extends RefreshIconButtonProps {
	withTooltip?: boolean;
}

export const RefreshButton = ({
	onClick,
	loading = false,
	tooltip = "Refresh",
	withTooltip = true,
	className = "",
}: RefreshButtonProps) =>
	withTooltip ? (
		<Tooltip>
			<TooltipTrigger asChild>
				<div>
					<RefreshIconButton onClick={onClick} loading={loading} className={className} tooltip={tooltip} />
				</div>
			</TooltipTrigger>
			<TooltipContent>{tooltip}</TooltipContent>
		</Tooltip>
	) : (
		<RefreshIconButton onClick={onClick} loading={loading} className={className} tooltip={tooltip} />
	);

const RefreshIconButton = forwardRef<HTMLButtonElement, RefreshIconButtonProps>(
	({ onClick, loading = false, className = "", tooltip = "Refresh" }, ref) => (
		<Button
			ref={ref}
			variant="outline"
			size="sm"
			onClick={onClick}
			disabled={loading}
			className={`hover:bg-muted/70 transition ${className}`}
			aria-label={tooltip}
		>
			{loading ? (
				<Loader2 className="w-3.5 h-3.5 animate-spin text-muted-foreground" />
			) : (
				<RefreshCw className="w-3.5 h-3.5" />
			)}
		</Button>
	),
);

RefreshIconButton.displayName = "RefreshIconButton";
